module.exports = __webpack_public_path__ + "img/vr.430882a2.gif";